import IconButton from "@material-ui/core/IconButton";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import * as _ from "lodash";
import MUIDataTable from "mui-datatables";
import * as React from "react";
import { connect } from "react-redux";

import { CustomerGroupBody } from "../../lib/models/CustomerGroup";
import { DatatableBody } from "../../lib/models/Datatable";
import { StoreState } from "../../store";
import { isFeatureEnabled, numberFormat } from "../../utilities";

const columns = [
  {
    id: "customer_number",
    name: "GP Nummer",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    id: "customer_first_name",
    name: "Vorname",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    id: "customer_last_name",
    name: "Nachname",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    id: "clv",
    name: "CLV",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "diff_clv",
    name: "Differenz CLV",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "reason_diff_clv",
    name: "Grund Differenz CLV",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "churn_score",
    name: "Churn Score",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "current_churn_score_since",
    name: "Kündigungsrisiko seit (Wochen)",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "diff_churn",
    name: "Differenz Churn Score",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "reason_diff_churn",
    name: "Grund Differenz Churn Score",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "is_company",
    name: "Firma",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    id: "salutation_category",
    name: "Anrede",
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    id: ["customer_addr_street", "customer_addr_house_number"],
    name: "Straße + Hausnummer",
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    id: "customer_addr_city",
    name: "Ort",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    id: "customer_addr_postal_code",
    name: "PLZ",
    options: {
      filter: true,
      sort: true,
    },
  },
]
  .concat(
    isFeatureEnabled(process.env.REACT_APP_FEATURE_HOUSING_SITUATION)
      ? [
          {
            id: "building_type",
            name: "Gebäudetyp",
            options: {
              filter: false,
              sort: true,
            },
          },
          {
            id: "building_age",
            name: "Gebäudealter",
            options: {
              filter: false,
              sort: true,
            },
          },
        ]
      : []
  )
  .concat([
    {
      id: "customer_telephone",
      name: "Telefonnummer",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      id: "customer_email",
      name: "E-Mail-Adresse",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      id: "product_name_electricity",
      name: "Strom",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      id: "product_name_gas",
      name: "Gas",
      options: {
        filter: true,
        sort: true,
      },
    },
  ])
  .concat(
    isFeatureEnabled(process.env.REACT_APP_FEATURE_GLASS_FIBER)
      ? [
          {
            id: "product_name_glass_fiber",
            name: "Glasfaser",
            options: {
              filter: true,
              sort: true,
            },
          },
        ]
      : []
  )
  .concat([
    {
      id: "has_district_heating",
      name: "Wärme",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "online_customer",
      name: "Online Kunde",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "customer_duration_years",
      name: "Kunde seit (Jahre)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: ["last_contact_class", "last_contact_activity"],
      name: "letzter Kontaktinhalt",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      id: "customer_age",
      name: "Alter",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "age_predicted",
      name: "Alter (geschätzt)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "opt_in_phone",
      name: "Opt In (Telefon)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "opt_in_mail",
      name: "Opt In (Post)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "opt_in_email",
      name: "Opt In (E-Mail)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      id: "nba_name",
      name: "Beratungsfokus",
      options: {
        filter: false,
        sort: true,
      },
    },
  ]);

function mapStateToProps({ housingSituations }: StoreState) {
  return {
    housingSituations,
  };
}
type Props = {
  data: DatatableBody | CustomerGroupBody;
  fetchData: (
    page: number,
    rowsPerPage: number,
    filter?: { [field: string]: string },
    sortBy?: string,
    sortDirection?: string
  ) => void;
  getDownloadHref?: (
    tableFilter?: { [field: string]: string },
    sortBy?: string,
    sortDirection?: string
  ) => string;
} & ReturnType<typeof mapStateToProps>;

interface State {
  filterList: string[][];
  page: number;
  rowsPerPage: number;
  sortBy: string | undefined;
  sortDirection: string | undefined;
}
class MyTable extends React.Component<Props, State> {
  public state = {
    filterList: [],
    page: 0,
    rowsPerPage: 10,
    sortBy: undefined,
    sortDirection: undefined,
  };

  public async componentDidMount() {
    this.fetchData();
  }

  public render() {
    const { count } = this.props.data.meta;
    const { page, rowsPerPage } = this.state;
    const customToolbar = this.props.getDownloadHref
      ? () => (
          <Tooltip title="Download">
            <IconButton
              href={this.props.getDownloadHref!(
                this.getFilter(),
                this.state.sortBy,
                this.state.sortDirection
              )}
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        )
      : undefined;

    const options = {
      count,
      customToolbar,
      download: false,
      filterType: "textField",
      onTableChange: this.onTableChange,
      page,
      print: false,
      responsive: "scroll",
      rowsPerPage,
      search: false,
      selectableRows: false,
      serverSide: true,
      textLabels: {
        body: {
          noMatch: "Es wurden leider keine passenden Zeilen gefunden",
          toolTip: "Sortieren",
        },
        filter: {
          all: "Alle",
          reset: "ZURÜCKSETZEN",
          title: "FILTER",
        },
        pagination: {
          displayRows: "von",
          next: "Nächste Seite",
          previous: "Vorherige Seite",
          rowsPerPage: "Zeilen pro Seite:",
        },
        selectedRows: {
          delete: "Löschen",
          deleteAria: "Ausgewählte Zeilen löschen",
          text: "Zeilen ausgewählt",
        },
        toolbar: {
          downloadCsv: "Download CSV",
          filterTable: "Tabelle filtern",
          print: "Drucken",
          search: "Suche",
          viewColumns: "Spalten anzeigen",
        },
        viewColumns: {
          title: "Spalten anzeigen",
          titleAria: "Spalten ein-/ausblenden",
        },
      },
      viewColumns: false,
    };

    return (
      <MuiThemeProvider theme={this.getMuiTheme()}>
        <MUIDataTable
          title="Kunden"
          data={this.processData(this.props.data.data)}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    );
  }

  private getFilter = () => {
    return this.state.filterList.reduce((accu, current, index) => {
      const id = columns[index].id;
      return {
        ...accu,
        [typeof id === "string" ? id : id[0]]: current,
      };
    }, {});
  };

  private fetchData = () => {
    this.props.fetchData(
      this.state.page,
      this.state.rowsPerPage,
      this.getFilter(),
      this.state.sortBy,
      this.state.sortDirection
    );
  };

  private onTableChange = (action: string, tableState: any) => {
    switch (action) {
      case "changePage":
        this.changePage(tableState.page);
        break;
      case "changeRowsPerPage":
        this.changeRowsPerPage(tableState.rowsPerPage);
        break;
      case "sort":
        const { sortDirection } = tableState.columns[tableState.activeColumn];
        this.sort(tableState.activeColumn, sortDirection);
        break;
      case "filterChange":
        this.filterChange(tableState.filterList);
        break;
      case "resetFilters":
        this.resetFilter();
        break;
      default:
        // tslint:disable
        console.log(action, tableState);
    }
  };

  private filterChange = _.debounce((filterList: string[][]) => {
    this.setState({ filterList }, this.fetchData);
  }, 1000);

  private resetFilter = () => {
    this.setState({ filterList: [] }, this.fetchData);
  };

  private sort = (activeColumn: number, sortDirection: string) => {
    const { id } = columns[activeColumn];
    const sortBy = typeof id === "string" ? id : id[0];
    this.setState({ sortBy, sortDirection }, this.fetchData);
  };

  private changePage = (page: number) => {
    this.setState({ page }, this.fetchData);
  };

  private changeRowsPerPage = (rowsPerPage: number) => {
    this.setState({ rowsPerPage }, this.fetchData);
  };

  private getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            whiteSpace: "nowrap",
          },
        },
        MUIDataTable: {
          responsiveScroll: {
            maxHeight: "none",
          },
        },
      } as any,
      palette: {
        primary: { main: "#002E5F" },
        secondary: { contrastText: "#fff", main: "#00A8E1" },
      },
      typography: {
        fontFamily: ["Arial", "sans-serif"].join(","),
      },
    });

  private getBuildingTypeName = (id: string | undefined) => {
    if (id) {
      return (
        this.props.housingSituations.buildingTypes.find(
          (buildingType) => buildingType.id === parseInt(id)
        )?.name ?? ""
      );
    }
    return "";
  };
  private getBuildingAgeName = (id: string | undefined) => {
    if (id) {
      return (
        this.props.housingSituations.buildingAges.find(
          (buildingAge) => buildingAge.id === parseInt(id)
        )?.name ?? ""
      );
    }
    return "";
  };

  private processData(data: any[]) {
    return data.map((row: any) => {
      return columns.map((column) => {
        if (column.id === "building_type") {
          return this.getBuildingTypeName(
            row[column.id]?.length && row[column.id][0]
          );
        } else if (column.id === "building_age") {
          return this.getBuildingAgeName(
            row[column.id]?.length && row[column.id][0]
          );
        } else if (typeof column.id === "string") {
          if (column.id === "clv" || column.id === "churn_score") {
            row[column.id] =
              row[column.id] !== null ? numberFormat(row[column.id], true) : "";
          }
          const value = row[column.id];
          return typeof value === "boolean"
            ? value
              ? "ja"
              : "nein"
            : row[column.id];
        } else {
          return column.id.map((id) => row[id]).join(" ");
        }
      });
    });
  }
}

export default connect(mapStateToProps)(MyTable);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/MyTable.tsx